import ExpenseAccountTable from "./view/ExpenseAccountTable";

const ExpenseAccount = () => {
  return <ExpenseAccountTable />;
};

export default ExpenseAccount;
